import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import { FILTER_BUTTON_WIDTH, ICON_ARROW_WIDTH, SCROLL_DIRECTIONS } from './constants';
var useScroll = function (tabsRef) {
    var _a = useState(false), canScrollLeft = _a[0], setCanScrollLeft = _a[1];
    var _b = useState(false), canScrollRight = _b[0], setCanScrollRight = _b[1];
    var SCROLL_LEFT = SCROLL_DIRECTIONS.SCROLL_LEFT, SCROLL_RIGHT = SCROLL_DIRECTIONS.SCROLL_RIGHT;
    var tabsNode = tabsRef.current;
    var getOverflowValues = function () {
        var isOverflowedLeft = false;
        var isOverflowedRight = false;
        var overflowLeft = 0;
        var overflowRight = 0;
        var tabsNode = tabsRef.current;
        if (tabsNode) {
            var scrollWidth = tabsNode.scrollWidth, clientWidth = tabsNode.clientWidth, scrollLeft = tabsNode.scrollLeft;
            overflowLeft = scrollLeft;
            overflowRight = scrollWidth - clientWidth - scrollLeft;
            isOverflowedLeft = overflowLeft > ICON_ARROW_WIDTH;
            isOverflowedRight = overflowRight > ICON_ARROW_WIDTH;
        }
        return {
            canScrollLeft: isOverflowedLeft,
            canScrollRight: isOverflowedRight,
            overflowLeft: overflowLeft,
            overflowRight: overflowRight
        };
    };
    var handleResize = function () {
        var _a = getOverflowValues(), canScrollLeft = _a.canScrollLeft, canScrollRight = _a.canScrollRight;
        if (tabsRef.current) {
            setCanScrollLeft(canScrollLeft);
            setCanScrollRight(canScrollRight);
        }
    };
    var debounceHandleResize = debounce(handleResize, 1000);
    useEffect(function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', debounceHandleResize);
            debounceHandleResize();
        }
        return function () {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', debounceHandleResize);
            }
        };
    }, [debounceHandleResize]);
    var handleScroll = function (e) {
        if (e.currentTarget)
            handleResize();
    };
    var handleScrollLeft = function (overflowLeft) {
        var scrollValue = Math.min(FILTER_BUTTON_WIDTH, overflowLeft);
        if (tabsNode)
            tabsNode.scrollLeft -= scrollValue;
    };
    var handleScrollRight = function (overflowRight) {
        var scrollValue = Math.min(FILTER_BUTTON_WIDTH, overflowRight);
        if (tabsNode)
            tabsNode.scrollLeft += scrollValue;
    };
    var onScrollClick = function (direction) {
        var _a = getOverflowValues(), canScrollLeft = _a.canScrollLeft, canScrollRight = _a.canScrollRight, overflowLeft = _a.overflowLeft, overflowRight = _a.overflowRight;
        if (tabsNode) {
            setCanScrollLeft(canScrollLeft);
            setCanScrollRight(canScrollRight);
            if (direction === SCROLL_RIGHT) {
                handleScrollRight(overflowRight);
            }
            else if (direction === SCROLL_LEFT) {
                handleScrollLeft(overflowLeft);
            }
        }
    };
    return {
        debounceHandleResize: debounceHandleResize,
        handleScroll: handleScroll,
        onScrollClick: onScrollClick,
        canScrollLeft: canScrollLeft,
        canScrollRight: canScrollRight
    };
};
export default useScroll;
